(function ($) {
  // Function to handle scroll event.
  function handleScroll() {
    if (window.scrollY > 100) {
      $(".site-header").addClass("scrolled");
    } else {
      $(".site-header").removeClass("scrolled");
    }
  }

  // Attach the scroll event to the window
  $(window).on("scroll", handleScroll);

  // Call the function initially to check the scroll position on page load
  handleScroll();
})(jQuery);

// Handles the opening and closing of the Newsletter Modal.
document.addEventListener("DOMContentLoaded", function () {
  const modal = document.querySelector(".newsletter-modal");
  const buttons = document.querySelectorAll(".subscribe-button");
  const closeButton = document.querySelector(".close-modal");
  const body = document.body;

  buttons.forEach(button => {
    button.addEventListener("click", function () {
      if (modal) {
        modal.classList.add("active");
        body.style.overflow = 'hidden';
      }
    });
  });

  // Close modal when clicking the close button
  closeButton.addEventListener("click", function () {
    modal.classList.remove("active");
    body.style.overflow = 'auto';
  });

  // Close modal when clicking outside the content
  modal.addEventListener("click", function (e) {
    if (e.target === this) {
      this.classList.remove("active");
      body.style.overflow = 'auto';
    }
  });
});
